'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    CarouselNavContextProvider: function() {
        return CarouselNavContextProvider;
    },
    carouselNavContextDefaultValue: function() {
        return carouselNavContextDefaultValue;
    },
    useCarouselNavContext: function() {
        return useCarouselNavContext;
    },
    useCarouselNavContextValues_unstable: function() {
        return useCarouselNavContextValues_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const carouselNavContext = /*#__PURE__*/ _react.createContext(undefined);
const carouselNavContextDefaultValue = {
    appearance: undefined
};
const useCarouselNavContext = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(carouselNavContext)) !== null && _React_useContext !== void 0 ? _React_useContext : carouselNavContextDefaultValue;
};
const CarouselNavContextProvider = carouselNavContext.Provider;
function useCarouselNavContextValues_unstable(state) {
    const { appearance } = state;
    const carouselNav = _react.useMemo(()=>({
            appearance
        }), [
        appearance
    ]);
    return {
        carouselNav
    };
}
